import firebase from "./FirebaseService";

class ReviewService {
	
	async addReview(author, stars, review) {
		if(stars === 0) {
			throw new Error("You have to give at least one star");
		}
		else if(review.length === 0) {
			throw new Error("Please write a brief review");
		}
		else {
			try {

				await firebase.firestore().collection("reviews").add({
					author: author,
					stars: stars,
					review: review,
					date: new Date()
				});

			}
			catch(error) {
				throw new Error("An error has occured, please try again later");
			}
		}
	}

	async getReviews(limit) {

		try {
			
			const results = await firebase.firestore().collection("reviews").limit(limit).orderBy("date", "desc").get();
			const docs = results.docs;
			
			let reviews = [];

			for(let i = 0; i < docs.length; i++) {

				const userResults = await firebase.firestore().collection("users").doc(docs[i].get("author")).get();

				reviews.push({
					name: userResults.get("name"),
					stars: docs[i].get("stars"),
					review: docs[i].get("review"),
					date: docs[i].get("date"),
				});
			}

			
			return reviews;
		
		}
		catch(error) {
			throw new Error("An error has occured, please try again later");
		}
	}

}

export default ReviewService;